<template>
  <main :id="$style.main">
    <main-title
      :class="$style.main_title"
      :main_title="'ホームランカード'"
      :sub_title="'〜 Home Run Card 〜'"
      :color="'#192C58'"
      :align="'center'"
    ></main-title>

    <div :class="$style.overview">
      <p>
        松井秀喜の日米でのすべての<br :class="$style.sp_indention">
        ホームランをカード化し、<br :class="$style.sp_indention">
        全国のホームランカード愛好者に<br :class="$style.sp_indention">
        配布されたものです。
      </p>
      <p>
        プロ野球選手個人のすべての<br :class="$style.sp_indention">
        ホームランシーンが<br :class="$style.sp_indention">
        カード化されている選手は、<br :class="$style.sp_indention">
        日米を通しても稀なことです。
      </p>
      <p>(企画・制作 日本テレビ)</p>
    </div>

    <div :class="$style.current_selector">{{currentFilter}}</div>
    <div :class="$style.title_container">
      <div :class="$style.filters">
        <span
          :class="[$style.filter, { active: currentFilter === 'ALL' }]"
          @click="setFilter('ALL')"
          >ALL</span
        >
        <span
          v-for="year in years"
          :key="year"
          :class="[
            $style.filter,
            { active: currentFilter === year.toString() },
          ]"
          @click="setFilter(year.toString())"
          >{{year}}</span
        >
      </div>
    </div>

    <transition-group
      :class="$style.cards"
      :enter-class="$style.enter"
      :leave-to-class="$style.leave_to"
      :leave-active-class="$style.leave_active"
    >
      <div :class="$style.card" v-for="card in activeCards" :key="card.career" ontouchstart="">
        <div :class="$style.card_wrapper">
          <div :class="$style.card_image_wrapper">
            <img :src="getPic(card.img)" />
          </div>
          <div :class="$style.card_title_wrapper">
            <span :class="$style.card_title">
              <b>{{ card.career }}</b>号<br />
              年月日：{{ card.date }}
            </span>
          </div>
        </div>
        <div :class="$style.card_info">
          対戦相手：{{ card.advrs }}<br />
          対戦投手：{{ card.picher }}<br />
          場所：{{ card.place }}<br /><br />
          comment<br />
          {{ card.comment }}<br /><br />
          situation<br />
          {{ card.situation }}<br />
        </div>
        <!-- overlay -->
        <div :class="$style.gradient_overlay"></div>
        <div :class="$style.color_overlay"></div>
      </div>
    </transition-group>
    <header-return></header-return>
  </main>
</template>

<script lang="ts">
import Vue from "vue";
import MainTitle from "@/components/atoms/MainTitle.vue";
import { ylist } from "../../assets/json/hrcard/hrcard_ob";
import HeaderReturn from "@/components/organsms/HeaderReturn.vue";

export default Vue.extend({
  name: "HRCardView",
  components: {
    MainTitle,
    HeaderReturn,
  },
  data() {
    return {
      currentFilter: "ALL",
      Cards: ylist,
      ylist
    };
  },
  computed: {
    activeCards: function () {
      const currentFilter = this.currentFilter;
      return this.Cards.filter(function (card) {
        return parseInt(currentFilter) === parseInt(card.date.slice(0,4)) || currentFilter === "ALL";
      });
    },
    items: function () {
      return this.ylist;
    },
    years: function () {
      const range = (start, stop) =>
        Array.from({ length: stop - start }, (_, i) => start + i);
      return range(1993, 2013);
    }
  },
  mounted() {},
  methods: {
    setFilter: function (filter) {
      this.currentFilter = filter;
    },

    getPic(cardnum) {
      return "/img/hrcard/faceup/" + cardnum;
    },
  },
});
</script>

<style lang="scss">
// SP PreviewのためのCSS
@media only screen and (max-width: 1023px) {
}
// PC PreviewのためのCSS
@media only screen and (min-width: 1024px) {
}
</style>

<style lang="scss" module>
@import "../../assets/style/base.scss";
@import url('https://fonts.googleapis.com/css2?family=Alfa+Slab+One&display=swap');

@media only screen and (max-width: 1023px) {

$card_height: 350px;
$card_width: 88%;

  #main {

    .title_container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      overflow:  scroll;
      direction: rtl;
    }

    .overview {
      margin: 2em 0;
      text-align: center;
    }

    .sp_indention {
      display: block;
    }

    .current_selector {
      text-align: center;
      margin-top:8px;
      font-size: 34px;
      color: #19448e;
      font-family: Alfa Slab One;
      letter-spacing: 3px;
    }

    .filter {
      padding: 9px 9px;
      cursor: pointer;
      border-radius: 6px;
      transition: all 0.35s;
      font-size: 16px;
      //width:auto;
    }

    .filters {
      margin-bottom: 8px;
      width:auto;
      max-width: 100%;
    }

    .cards {
      margin-top: 20px;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
    }

    .enter {
      transform: scale(0.5) translatey(-8px);
      opacity: 0;
    }

    .leave_to {
      transform: translatey(30px);
      opacity: 0;
    }

    .leave_active {
      position: absolute;
      z-index: -1;
    }

    .card {
      transition: all 0.35s ease-in-out;
      margin: 8px 0px;
      box-shadow: 0px 1px 4px lightgrey;
      border-radius: 10px;
      width: $card_width;
      max-width: 385px;
      height: $card_height;
      position: relative;
      /* display: flex; */
      /* flex-direction: column; */
      /* justify-content: center; */
      /* align-items: center; */
      &:hover{
        .card_info {
          opacity: 1;
          /* bottom: 120px; */
        }
        .color_overlay {
          width: 100%;
          height: $card_height;
          position: absolute;
          top: 0px;
          left: 0px;
          border-radius: 10px;
          z-index: 10;
          transition: background 0.3s cubic-bezier(0.33, 0.66, 0.66, 1);
          background: rgba(74, 82, 76, 0.88);
          background-image: -webkit-linear-gradient(
            top,
            rgba(0, 0, 0, 0.6) 0%,
            rgba(0, 0, 0, 0) 21%
          );
          background-image: -moz-linear-gradient(
            top,
            rgba(0, 0, 0, 0.6) 0%,
            rgba(0, 0, 0, 0) 21%
          );
          background-image: -o-linear-gradient(
            top,
            rgba(0, 0, 0, 0.4) 0%,
            rgba(0, 0, 0, 0) 21%
          );
          background-image: linear-gradient(
            to bottom,
            rgba(0, 0, 0, 0.6) 0%,
            rgba(0, 0, 0, 0) 20%
          );
          border-radius: 10px;
        }
      }
    }

    .card_wrapper {
      display: flex;
      flex-direction: column;
      justify-content: center;
      text-align: center;
      height: 100%;
      width: 100%;
    }

    .card_image_wrapper {
      position: relative;
      max-height: 100%;
      height: 80%;
      overflow: hidden;
      img {
        position: absolute;
        top: 50%;
        left: 50%;
        -webkit-transform : translate(-50%,-50%);
        transform : translate(-50%,-50%);
        object-fit: contain;
        width: 95%;
        height: 95%;
      }
    }

    .card_title_wrapper {
      border-top: solid 1px lightgrey;
      height: 15%;
      padding: 5px;
    }

    .card_info {
      width: 100%;
      height: $card_height;
      position: absolute;
      top: 0px;
      left: 0px;
      /* bottom: 100px; */
      /* left: 0; */
      margin: 0 auto;
      padding: 10px 15px;
      color: white;
      font-size: 13px;
      line-height: 20px;
      z-index: 20;
      opacity: 0;
      overflow: scroll;
      transition: top 0.3s opacity 0.3s cubic-bezier(0.4, 0.56, 0.48, 0.98);
    }

    .card_title {
      font-size: 9pt;
      margin-top: 5px;
    }
  }
}


@media only screen and (min-width: 1024px) {
  // variables
  $card-width: 235px;
  $card-height: 250px;
  $h-color: #9cc9e3;
  $yellow: #d0bb57;
  $txt-color: #dce3e7;

  #main {
    .title_container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      overflow: scroll;
    }

    img {
      max-width: 100%;
      max-height: 100%;
      width: auto;
      height: auto;
    }

    .overview {
      margin: 3em 0;
      text-align: center;
    }

    .sp_indention {
      display: none;
    }

    .current_selector {
      text-align: center;
      margin-top:8px;
      font-size: 34px;
      color: #19448e;
      font-family: Alfa Slab One;
      letter-spacing: 3px;
    }

    .filter {
      padding: 9px 9px;
      cursor: pointer;
      border-radius: 6px;
      transition: all 0.35s;
      font-size: 22px;
    }

    .filter .active {
      box-shadow: 0px 1px 3px 0px #00000026;
      font-size: 30px;
    }

    .filter:hover {
      background: lightgray;
    }

    .filters {
      border-bottom: solid 1px;
      border-color: #49638f;
      max-width: 100%;
    }

    .cards {
      margin-top: 20px;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      position: static;
    }

    .enter {
      transform: scale(0.5) translatey(-8px);
      opacity: 0;
    }

    .leave_to {
      transform: translatey(30px);
      opacity: 0;
    }

    .leave_active {
      position: absolute;
      z-index: -1;
    }

    .card {
      transition: all 0.35s ease-in-out;
      margin: 10px;
      box-shadow: 0px 1px 4px lightgrey;
      border-radius: 10px;
      width: 235px;
      height: 250px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      &:hover {
        .card_info {
          opacity: 1;
          /* bottom: 120px; */
        }
        .color_overlay {
          background: rgba(74, 82, 76, 0.9);
          background-image: -webkit-linear-gradient(
            top,
            rgba(0, 0, 0, 0.6) 0%,
            rgba(0, 0, 0, 0) 21%
          );
          background-image: -moz-linear-gradient(
            top,
            rgba(0, 0, 0, 0.6) 0%,
            rgba(0, 0, 0, 0) 21%
          );
          background-image: -o-linear-gradient(
            top,
            rgba(0, 0, 0, 0.4) 0%,
            rgba(0, 0, 0, 0) 21%
          );
          background-image: linear-gradient(
            to bottom,
            rgba(0, 0, 0, 0.6) 0%,
            rgba(0, 0, 0, 0) 20%
          );
          border-radius: 10px;
        }
      }
    }

    .card_info {
      width: 100%;
      height: 100%;
      /* position: absolute; */
      bottom: 100px;
      /* left: 0; */
      margin: 0 auto;
      padding: 10px 15px;
      color: white;
      font-size: 11px;
      line-height: 20px;
      z-index: 20;
      opacity: 0;
      overflow: scroll;
      transition: top 0.3s opacity 0.3s cubic-bezier(0.4, 0.56, 0.48, 0.98);
    }

    .color_overlay {
      width: $card-width;
      height: $card-height;
      position: absolute;
      border-radius: 10px;
      z-index: 10;
      transition: background 0.3s cubic-bezier(0.33, 0.66, 0.66, 1);
    }

    .gradient_overlay {
      width: $card-width;
      height: $card-height;
      position: absolute;
      z-index: 15;
    }

    .card_wrapper {
      display: flex;
      flex-direction: column;
      justify-content: center;
      text-align: center;
      position: absolute;
    }

    .card_image_wrapper {
      position: relative;
      width: 200px;
      height: 200px;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        padding-top: 3px;
      }
    }

    .card_title {
      font-size: 9pt;
      margin-top: 5px;
    }
  }
}
</style>
